import "./Contact.module.css";
import Naglowek from "@/reusable_sections/Header";
import DaneKontaktoweIFormularz from "./sections/DaneKontaktoweIFormularz";
import FAQ from "./sections/FAQ";
import Stopka from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Naglowek />
      <DaneKontaktoweIFormularz />
      <FAQ />
      <Stopka />
    </div>;
}